import { useTranslation } from 'react-i18next';

// URL mappings for different languages
// Rutas en español → su equivalente en inglés (y francés, heredado y sin uso).
// Es la ÚNICA tabla: la usan los enlaces (getLocalizedUrl) y el selector de idioma
// (switchLanguagePath). Solo deben figurar páginas que existan en inglés (rutas
// /:lang/... de App.jsx); las que no estén aquí llevan a la home del otro idioma.
// Revisada el 4-nov-2026 al rehacer la versión inglesa.
export const URL_MAPPINGS = {
  '/plataforma': { en: '/platform', fr: '/plateforme' },
  '/interoperabilidad': { en: '/interoperability', fr: '/interoperabilite' },
  '/cargadores': { en: '/shippers' },
  '/transportistas': { en: '/carriers' },
  '/proveedores-software': { en: '/software-providers' },
  '/documentos/ecmr': { en: '/documents/ecmr', fr: '/documents/ecmr' },
  '/documentos/carta-porte': { en: '/documents/road-waybill' },
  '/documentos/documento-control': { en: '/documents/control-document' },
  '/documentos/transporte-adr': { en: '/documents/adr-transport-document' },
  '/confianza/firma-electronica': { en: '/trust/electronic-signature', fr: '/confiance/signature-electronique' },
  '/confianza/seguridad': { en: '/trust/security', fr: '/confiance/securite' },
  '/confianza/cumplimiento-normativo': { en: '/trust/regulatory-compliance', fr: '/confiance/conformite-reglementaire' },
  '/quienes-somos': { en: '/about-us', fr: '/qui-sommes-nous' },
  '/contacto': { en: '/contact', fr: '/contact' },
  '/contacto/demo': { en: '/contact/demo', fr: '/contact/demo' },
  '/contacto/formulario': { en: '/contact/form', fr: '/contact/form' },
  '/contacto/llamada': { en: '/contact/call', fr: '/contact/call' },
  '/aviso-legal': { en: '/legal-notice', fr: '/legal-notice' },
  '/terminos': { en: '/terms', fr: '/terminos' },
  '/privacidad': { en: '/privacy', fr: '/confidentialite' },
  '/cookies': { en: '/cookies', fr: '/cookies' },
  '/dpa': { en: '/dpa', fr: '/dpa' },
};

/**
 * Ruta equivalente en otro idioma para el selector «ES | EN». Si la página no
 * existe en el idioma de destino, la home de ese idioma.
 */
export const switchLanguagePath = (pathname, target) => {
  const clean = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  const m = clean.match(/^\/(en|fr)(\/.*)?$/);
  let esPath = clean;
  if (m) {
    const rest = m[2] || '/';
    esPath = rest === '/' ? '/' : Object.keys(URL_MAPPINGS).find((k) => URL_MAPPINGS[k][m[1]] === rest) || null;
  }
  if (target === 'es') return esPath || '/';
  if (!esPath || esPath === '/') return `/${target}`;
  const mapped = URL_MAPPINGS[esPath]?.[target];
  return mapped ? `/${target}${mapped}` : `/${target}`;
};

export const useLocalizedUrl = () => {
  const { i18n } = useTranslation();
  
  const getLocalizedUrl = (path) => {
    const lang = i18n.language;
    
    // Spanish doesn't need prefix
    if (lang === 'es') {
      return path;
    }
    
    // Map to localized path if available
    const localizedPath = URL_MAPPINGS[path]?.[lang] || path;
    
    // Add language prefix
    return `/${lang}${localizedPath}`;
  };
  
  return { getLocalizedUrl };
};

// Static version for use outside components
export const getLocalizedUrlStatic = (path, language) => {
  if (language === 'es') {
    return path;
  }
  
  // Map to localized path if available
  const localizedPath = URL_MAPPINGS[path]?.[language] || path;
  
  return `/${language}${localizedPath}`;
};